export default class Indexation {
  constructor(id, name, typeNumber) {
    this.id = id;
    this.name = name;
    this.typeNumber = typeNumber;
  }

  static createNew() {
    return new Indexation(
      null,
      null,
      null,
    );
  }
}
